
    <app-kontable
      *ngIf="!show"
      title="{{ 'promotion.messageTypeTitle' | translate }}"
      [columns]="['id', 'code', 'description']"
      [titles]="['#', 'promotion.code', 'promotion.description']"
      [source]="messageType"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="addMessageType()"
      (onEdit)="editMessageType($event)"
      (onRemove)="deleteMessageType($event)">
    </app-kontable>
    <kv-promo-message-type-detail
      *ngIf="show"
      [messageType]="addEditMessageType"
      [titlePage]="titlePage"
      (hide)="toggleShow()"
      (saveMessageType)="save($event)">
    </kv-promo-message-type-detail>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/message-type/message-type.component.ts.MessageTypeComponent.html